export function convertImperialToMetric(feet: number, inches: number) {
  const totalInches = feet * 12 + inches;

  return Math.round(totalInches * 2.54);
}

export function convertMetricToImperial(cm: number): { feet: number; inches: number } {
  const realFeet = (cm * 0.3937) / 12;
  const feet = Math.floor(realFeet);
  const inches = Math.round((realFeet - feet) * 12);

  return { feet, inches };
}

export function convertMetersToCentimeters(meters: number) {
  return meters * 100;
}

export function convertCentimetersToMeters(centimeters: number) {
  return centimeters / 100;
}
